import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { FormGroup, FormArray, FormBuilder, FormControl } from '@angular/forms';

@Component({
  selector: 'digicem-pin-field',
  templateUrl: './pin-field.component.html',
})
export class PinFieldComponent implements OnInit {
  @Input() numOfDigits = 4;
  @Input() hasError = false;
  @Output() codeFilled = new EventEmitter<string>();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @ViewChildren('inputs') inputs!: QueryList<any>;

  pinForm!: FormGroup;

  get digits(): FormArray {
    return this.pinForm.get('digits') as FormArray;
  }

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.pinForm = this.fb.group({
      digits: this.fb.array([]),
    });

    for (let i = 0; i < this.numOfDigits; i++) {
      this.digits.push(new FormControl(null));
    }

    this.pinForm.valueChanges.subscribe(() => {
      const values = this.digits.value.join('');
      if (values.length === this.numOfDigits && !values.includes(null)) {
        this.codeFilled.emit(values);
      } else {
        this.codeFilled.emit('');
      }
    });
  }

  onInput(index: number, field: FormControl): void {
    const value = field.value;

    if (!/^\d$/.test(value)) {
      field.setValue(null);
      return;
    }

    const nextInput = this.inputs.toArray()[index + 1];
    nextInput?.nativeElement?.focus();
  }

  onKeydown(index: number, field: FormControl, event: KeyboardEvent): void {
    const key = event.key;

    if (key === 'Backspace') {
      if (field.value) {
        field.setValue(null);
      } else {
        const prevInput = this.inputs.toArray()[index - 1];
        prevInput?.nativeElement?.focus();
      }
    }
  }

  getControl(index: number): FormControl {
    return this.digits.at(index) as FormControl;
  }
}
